export default __webpack_public_path__ + "static/media/board-game.59ae47cb.svg";